var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"primary","dark":""}},'v-btn',attrs,false),on),[_vm._v("Open editor")])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"height":"100%"}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1),_c('v-toolbar-title',[_vm._v("Edit polygons")]),_c('v-spacer'),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","text":""},on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])],1)],1),_c('open-sea-dragon-viewer',{attrs:{"id":'osd-viewer',"options":{
          defaultZoomLevel: 1,
          minZoomLevel: 1,
          maxZoomLevel: 5,
          ajaxWithCredentials: false,
          showNavigator: false,
          showNavigationControl: false,
          showReferenceStrip: false,
          homeFillsViewer: true,
          constrainDuringPan: true,
          visibilityRatio: 1,
          iOSDevice: true,
          loadTilesWithAjax: true,
          ajaxWithCredentials: true,
          // ajaxHeaders: {
          // Example of using the viewer-level ajaxHeaders option
          // for providing an authentication token.
          //  Authorization: 'Bearer ' + apiCredentials
          // },
          animationTime: 0.5,
          immediateRender: true
        },"tile-sources":_vm.currentTileSources}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }